import { getUserPersona } from "@/utils/helper"

export const getBundleIncludedItems = (data = {}) => {
  const {
    currencyCode,
    items = [],
    ctData,
    projectionData = [],
    persona,
  } = data
  const sitePersona = persona
  const { masterVariant: { attributes = [] } = {} } = ctData

  return items.map(el => {
    const {
      sku_s: sku = "",
      slug_s: slug = "",
      productName_s: name = "",
      ColorFinish_s: color = "",
      ProductDescriptionProductShort_s: desc = "",
      ProductLocalCategory_s: category = "",
      ProductBrandNameDisplay_t: collection = "",
      category1_s: productRoom = "",
      ["productImages.labelWithUrl_ss"]: productImages,
      ["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"]: specPDFFiles,
      ["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"]:
        installGuides,
      ProductWebFeatures_ss: productFeatures = [],
      [`priceList.${sitePersona}.price_d`]: priceDiscount = 0,
      [`priceList.${sitePersona}.finalPrice_d`]: finalPriceDiscount = 0,
      [`priceList.${sitePersona}.discountedPrice_d`]: discountedPriceFinal = 0,
      [`priceList.${sitePersona}.saleOffer_s`]: saleOffer = 0,
      [`priceStartingAt.${sitePersona}_d`]: priceStart = 0,
    } = el

    const imageUrls =
      productImages
        .find(e => e.startsWith(sku))
        ?.split("|")
        ?.find(im => im.startsWith("http")) ?? ""

    const { value: productsData = [] } =
      attributes.find(e => e.name === "products") ?? {}

    const currentSkuCtData =
      productsData.find(pd => {
        return pd.find(vl => vl.value === sku)
      }) ?? []

    const { variants = [] } =
      projectionData.find(pj => {
        return pj.variants.find(ve => ve.sku === sku)
      }) ?? {}

    const { prices: variantsPrices = [] } =
      variants.find(e => e.sku === sku) ?? {}

    const { masterVariant: { prices: masterPrices } = {} } =
      projectionData.find(e => e.masterVariant.sku === sku) ?? {}

    const prices = masterPrices ? masterPrices : variantsPrices

    const persona = getUserPersona()

    let productPrice = prices?.find(
      price =>
        price.value?.currencyCode === currencyCode &&
        price.customerGroup?.obj?.key === persona
    )

    if (!productPrice?.value) {
      productPrice = prices?.find(
        price =>
          price.value?.currencyCode === currencyCode && !price.customerGroup
      )
    }

    const unitPrice = Number(
      ((productPrice?.value?.centAmount ?? 0) / 100).toFixed(2)
    )

    const discountedPrice = Number(
      ((productPrice?.discounted?.value?.centAmount ?? 0) / 100).toFixed(2)
    )

    let newData = {}
    currentSkuCtData.forEach(element => {
      const { name = "", value } = element
      newData = {
        ...newData,
        [name]: value,
      }
    })

    const { quantity } = newData

    return {
      name,
      desc,
      sku,
      category,
      productRoom,
      collection,
      image: imageUrls,
      color,
      slug,
      productFeatures,
      specPDFFiles,
      installGuides,
      quantity,
      unitPrice,
      discountedPrice,
      priceDiscount,
      finalPriceDiscount,
      discountedPriceFinal,
      saleOffer,
      priceStart,
    }
  })
}
